import useApiService from 'services/api'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import annotationPlugin from 'chartjs-plugin-annotation'
import { Chart } from 'chart.js'
import 'react-toggle/style.css'
import { SalesPipelineChart } from '../../../components/Charts/SalesPipelineChart'
import { DealsPipelineTable } from 'components/Tables/DealsPipelineTable/DealsPipelineTable'
import { FBPage } from 'components/FbUI/Page/FBPage'
import { InfoCard } from 'components/UI/InfoCard'
import { SalesForecast } from 'components/Dashboard/SalesForecast'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { Banner } from 'components/Banners/Banner'

Chart.register(ChartDataLabels)
Chart.register(annotationPlugin)

export function Dashboard() {
  const api = useApiService()
  const { enabledReportDeals } = useFeatureFlagService()
  const { data: overview } = api.useGetDashboardOverview(enabledReportDeals)

  return (
    <FBPage className="gap-y-4" noContainer innerPageClassName="!pb-0">
      <div className="flex flex-col min-h-full">
        {!enabledReportDeals && (
          <div className="mb-3">
            <Banner
              variant="warning"
              text="Our system is down for maintenance. Revenue calculations may be delayed to load or update."
            />
          </div>
        )}
        <div className="py-8 px-5 bg-surface rounded mb-3">
          <h3 className="text-4xl text-slate-900 font-bold mb-8">
            Deals Dashboard
          </h3>
          <div className="flex flex-row flex-wrap gap-4">
            {Object.entries(overview || {}).map(([k, v]) => (
              <InfoCard
                key={k}
                title={v.title}
                value={v.value}
                tooltip={v.tooltip}
              />
            ))}
          </div>
        </div>

        <div className="py-8 px-5 bg-surface rounded mb-3">
          <SalesForecast />
        </div>

        <div className="py-8 px-5 bg-surface rounded mb-3">
          <SalesPipelineChart />
        </div>

        <div className="py-8 px-5 bg-surface rounded mb-3">
          <DealsPipelineTable tableKey={'dashboard-table'} />
        </div>
      </div>
    </FBPage>
  )
}
